module.exports = __webpack_public_path__ + "static/media/ChrisWittich.af65825f.jpg";